import React, { useState } from 'react';
import type { FC } from 'react';
import { Box, Autocomplete, TextField } from '@mui/material';
import useAuth from 'src/hooks/useAuth';
import { Vendor } from 'src/types/vendor';
import useOnMount from 'src/hooks/useOnMount';
import VendorTypeAhead from './VendorTypeAhead';

declare interface Props {
  onChange: (value: NonNullable<string | Vendor>) => void;
  children?: React.ReactNode;
  style?: React.CSSProperties;

  //If true then the user's vendors will not be shown in the dropdown
  vendorsToExclude?: Vendor[];
}

const VendorDropdown: FC<Props> = ({ onChange, style, vendorsToExclude }) => {
  //vendors for simple dropdown if does not have impersonate vendor auth
  const [vendors, setVendors] = useState<Vendor[]>([]);
  const { user, hasImpersonateVendorAuth } = useAuth();

  useOnMount(() => {
    if (!hasImpersonateVendorAuth()) {
      //filter out vendorsToExclude list from user.vendors list by number
      if (vendorsToExclude && vendorsToExclude.length > 0) {
        let v = user.vendors.filter((x) => !vendorsToExclude.find((y) => y.number == x.number));
        setVendors(v);
      } else {
        setVendors(user.vendors);
      }
    }
  });

  if (hasImpersonateVendorAuth()) {
    return <VendorTypeAhead onChange={onChange} style={style} />;
    // } else if (vendors.length == 0) {
    //   return <div>Loading...</div>;
  } else {
    return (
      <Autocomplete
        multiple={false}
        id="vendorSearchSimple"
        disablePortal
        disableClearable
        style={style}
        options={[...vendors]}
        getOptionLabel={(option: Vendor) => option?.name ?? '' + ' (' + option?.numberString + ')'}
        renderOption={(p, option: Vendor) => {
          return (
            <div key={option.number}>
              <Box component="li" {...p}>
                <span style={{ fontSize: 'small' }}>{option.name + ' - ' + option.numberString}</span>
              </Box>
            </div>
          );
        }}
        onChange={(e, newValue: Vendor) => {
          onChange(newValue);
        }}
        isOptionEqualToValue={(option: Vendor, value: Vendor) => {
          return option.number === value?.number;
        }}
        // value={vendors.find((x) => x.number == vendor.number)}
        renderInput={(params) => (
          <TextField
            focused
            {...params}
            InputProps={{ ...params.InputProps, style: { fontSize: 14 } }}
            InputLabelProps={{ ...params.InputLabelProps, style: { fontSize: 14, fontWeight: 'bold' } }}
            label="Vendor"
          />
        )}
      />
    );
  }
};

export default VendorDropdown;
